<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
        <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo" value="1">
            <el-tab-pane :label="$t('getapi[1588]')" name="1" id="xpane-1">
                <div>
                    <el-button type="primary" size="mini" @click="editInfo" :disabled="isBtnRelease || authority_isBtnRelease">{{
                        $t('getapi[1587]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="updateVender" :disabled="isBtnUpSup">{{$t('getapi[8745]')}}</el-button>
                </div>
                <!-- <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                    <li style="width: 100%; margin-top:0px">
                        <wTable :data="dataSet" :selindex="SelectIndex" :loading="loading" queryData="PurRequisitionLineToOrderViewInfo" :header="tableHeader" @handleSelectionChange="handleSelectionChange" :option="tableOption"  @lct="lct"></wTable>
                    </li>
                </ul> -->
                <vTable
                        :data="dataSet"
                        :loading="loading"
                        queryData="PurRequisitionLineToOrderViewInfo"
                        :filter_language="['BatchPrice','Line_Status']"
                        :filter_thousandth="['Plan_Qty','already_pur_qty']"
                        :header="tableHeader"
                        :height="tableHeight"
                        @handleSelectionChange="handleSelectionChange"
                        @handleSelectionChangeAll="handleSelectionChangeAll"
                        @handleSelectionChangeEnd="handleSelectionChange"
                        :row-class-name="tableRowClassName"
                        ref="singleTable1"
                ></vTable>
                <!--<vxe-table
                        ref="singleTable1"
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        resizable
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        @checkbox-change="handleSelectionChange"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top:0px"
                        @sort-change="sortChange"
                        :sort-config="{remote: true}"
                        @checkbox-all="handleSelectionChangeAll"
                        @checkbox-range-end="handleSelectionChange"
                        :checkbox-config="{highlight: true, range: true}"
                        :mouse-config="{selected:true, extension: true}"
                >
                    <vxe-table-column type="checkbox" width="40"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Requisition_No"
                                     :title="$t('getapi[1480]')" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Part_Code"
                                     :title="$t('getapi[1579]')" sortable width="150"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="vender" :title="$t('getapi[3685]')" width="120" sortable>
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.vender"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="lct(scope)"></i>
                            </el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Audit_Time"
                                     :title="$t('getapi[6025]')" width="130" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Row_Number" :title="$t('getapi[1578]')"
                                     align="right" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Part_Name"
                                     :title="$t('getapi[1580]')" sortable width="150"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Part_Version"
                                     :title="$t('getapi[113]')" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Plan_Qty" :title="$t('getapi[1581]')"
                                     align="right" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Expect_Ship_Date"
                                     :title="$t('getapi[1584]')" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Purchase_Leadtime"
                                     :title="$t('getapi[1520]')" align="right" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="BatchPrice"
                                     :title="$t('getapi[1298]')" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="already_pur_qty" :title="$t('getapi[1582]')"
                                     align="right" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="orderid" :title="$t('getapi[1585]')" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="RowNumb" :title="$t('getapi[1586]')" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Consumption_Date" :title="$t('getapi[1512]')"
                                     align="right" sortable width="100"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="products" :title="$t('getapi[145]')" sortable width="100"></vxe-table-column>
                </vxe-table>-->
                <el-row>
                    <br/>
                    <el-col :span="12">
                        <span>{{$t('getapi[515]')}}{{dataSet.length}}{{$t('getapi[6771]')}}</span>
                    </el-col>
                </el-row>
                <!--<el-row>
                    <el-col :span="18">
                        <el-pagination
                                style="margin-top: 1em"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[100,200,300,400,500,1000]"
                                :page-size="100"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                        ></el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{
                            DbTbNames }}
                        </div>
                    </el-col>
                </el-row>-->
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[1589]')" name="2">
                <vxe-table
                        id="xpane-2"
                        ref="singleTable2"
                        :data="dataSet1"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight + 25"
                        header-row-class-name="headerclass"
                        @checkbox-change="handleSelectionChange"
                        @checkbox-all="handleSelectionChangeAll"
                        @checkbox-range-end="handleSelectionChangeEnd"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top:0px"
                >
                    <vxe-table-column align="center" type="checkbox" v-if="false" width="40"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Requisition_No"
                                     :title="$t('getapi[1480]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Part_Code"
                                     :title="$t('getapi[1579]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="vender" :title="$t('getapi[3685]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Audit_Time"
                                     :title="$t('getapi[6025]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Row_Number" :title="$t('getapi[1578]')"
                                     align="right" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Part_Name"
                                     :title="$t('getapi[1580]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Part_Version"
                                     :title="$t('getapi[113]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Plan_Qty" :title="$t('getapi[1581]')"
                                     align="right" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Expect_Ship_Date"
                                     :title="$t('getapi[1584]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Purchase_Leadtime"
                                     :title="$t('getapi[1520]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="BatchPrice"
                                     :title="$t('getapi[1298]')" sortable>
                        <template scope="scope">
                            <span>{{ scope.row.BatchPrice | lanchange}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="already_pur_qty" :title="$t('getapi[1582]')"
                                     align="right" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="orderid" :title="$t('getapi[1585]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="RowNumb" :title="$t('getapi[1586]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Consumption_Date" :title="$t('getapi[1512]')"
                                     align="right" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="products" :title="$t('getapi[145]')" sortable></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="partcodes" :title="$t('getapi[12745]')" sortable></vxe-table-column>
                </vxe-table>
                 <!-- <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                    <li style="width: 100%; margin-top:0px">
                        <wTable :data="dataSet" :selindex="SelectIndex" :loading="loading" queryData="PurRequisitionLineToOrderViewInfo" :header="tableHeader" @handleSelectionChange="handleSelectionChange" :option="tableOption"  @lct="lct"></wTable>
                    </li>
                </ul> -->
                <el-row class="page">
                    <el-col :span="18">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[100,200,300,400,500,1000]"
                                :page-size="pageSize1"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total1"
                        ></el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{
                            DbTbNames }}
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
        <serce :isVisible="isVisible" queryData="PurRequisitionLineToOrderViewInfo" ref="ser"
               @getser="serclick"></serce>
        <!-- 详情页面 -->
        <!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
        <!-- 供应商弹窗 -->
        <selector :isVisible="supplierVisible" :isSplitPage=true :postUrl="'/Pur/Order/GetMoreSupplybyPartPopupList'"
                  @callback="getSupplier" ref="supplier"></selector>
        <!-- 改变表格顺序 -->
		<ctable :isVisible="false" title="$t('getapi[102]')" queryData="PurRequisitionLineToOrderViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
		name:'purorderplanview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3- Common.reduceTableHeight1_1
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                dataSet1: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                // SelIndex:-1,
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 0, // 当前页
                pageSize: 100000, // 当前页数据量
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('purorderplanview1'), // 当前页数据量
                SelectIndex: 1, //当前页面
                total: 0, // 数据总量
                total1: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [], // 多选数组
                isBtnRelease: true, // 是否可执行转入下单按钮
                authority_isBtnRelease: false, // 权限——是否可下单
                isBtnUpSup: true, //
                supplierVisible: false, // 供应商弹窗
                dataSetindex: -1,// 选择供应商行号标识
                origin: -1, // 起点数
                pin: false, // 默认shift不按住
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
            // that.colsort();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[102]"),this.$t("getapi[16]"));
            },
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('PurRequisitionLineToOrderViewInfo',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                if(that.$limits.authority('plv3', 59, 1) > 0 && that.$limits.authority('plv4', 23, 1) == 1){
                    that.authority_isBtnRelease = false
                } else {
                    that.authority_isBtnRelease = true
                }
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 59, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 59, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    default:
                        break;
                }
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                // if (row.BatchPrice_color == '有') {
                //     return 'green';
                // } else if (row.BatchPrice == '有') {
                //     return 'red';
                // }
                if (row.moq > row.Plan_Qty) {
                    return 'red';
                } 
                else if (row.maxbatchprice_color>row.Plan_Qty && row.Plan_Qty>=row.moq && row.maxbatchprice_color>0) {
                    return 'yellow';
                }
                else if(row.maxbatchprice_color<=row.Plan_Qty && row.maxbatchprice_color>0){
                    return 'green';
                }
            },
            handleSizeChange(val) {
                let that = this;
                if (that.SelectIndex == 1) {
                    that.pageSize = val;
                } else if (that.SelectIndex == 2) {
                    that.pageSize1 = val;
                    this.$http.savePageSize('purorderplanview1',val)
                }
                that.getView();
                that.authority();
            },
            handleCurrentChange(val) {
                let that = this;
                if (that.SelectIndex == 0) {
                    that.pageIndex = val;
                } else if (that.SelectIndex == 1) {
                    that.pageIndex1 = val;
                }
                that.getView();
                that.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurRequisitionLineToOrderViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.SelectIndex==1?that.pageSize:that.pageSize1,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Order/PlanOrderDataList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 1) {
                            that.dataSet = res.DataContent;
                            that.selectData = [];
                            that.isBtnRelease = true
                            that.isBtnUpSup = true;
                            that.total = res.Totals;
                        } else {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        setTimeout(() => {
                            that.$nextTick(function(){
                                that.$processdata.initForm(that.SelectIndex)
                            });
                        }, 500);
                    }
                });
            },
            //全选
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectData.push({
                        part_code: records[i].Part_Code,
                        part_name: records[i].Part_Name,
                        part_version: records[i].Part_Version,
                        vender_code: records[i].vender,
                        requisition_no: records[i].Requisition_No,
                        plan_qty: records[i].Plan_Qty,
                        row_number: records[i].Row_Number,
                        exclusively_id: records[i].Exclusively_Id,
                        expect_ship_date: records[i].Expect_Ship_Date,
                        consumption_date: records[i].Consumption_Date,
                        check_flag: records[i].check_flag,
                        remark:records[i].remark
                    });
                }
                if (that.selectData.length > 1) {
                    // console.log('6666' + that.selectData[0].vender_code)
                    that.isBtnRelease = !that.selectData.every(val => {
                        return val.vender_code != '无供应商' && val.vender_code != '多供应商' && val.vender_code != '' && val.vender_code == that.selectData[0].vender_code;
                    });
                    that.isBtnUpSup = false;
                } else if (that.selectData.length == 1) {
                    if (that.selectData[0].vender_code != '无供应商' && that.selectData[0].vender_code != '多供应商' && that.selectData[0].vender_code != '') {
                        that.isBtnRelease = false;
                    } else {
                        that.isBtnRelease = true;
                    }
                    that.isBtnUpSup = false;
                } else if (that.selectData.length < 1) {
                    that.isBtnRelease = true;
                    that.isBtnUpSup = true;
                }
            },
            // 多选
            handleSelectionChange({checked, records }) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectData.push({
                        part_code: records[i].Part_Code,
                        part_name: records[i].Part_Name,
                        part_version: records[i].Part_Version,
                        vender_code: records[i].vender,
                        requisition_no: records[i].Requisition_No,
                        plan_qty: records[i].Plan_Qty,
                        row_number: records[i].Row_Number,
                        exclusively_id: records[i].Exclusively_Id,
                        expect_ship_date: records[i].Expect_Ship_Date,
                        consumption_date: records[i].Consumption_Date,
                        check_flag: records[i].check_flag,
                        remark:records[i].remark
                    });
                }
                if (that.selectData.length > 1) {
                    // console.log('6666' + that.selectData[0].vender_code)
                    that.isBtnRelease = !that.selectData.every(val => {
                        return val.vender_code != '无供应商' && val.vender_code != '多供应商' && val.vender_code != '' && val.vender_code == that.selectData[0].vender_code;
                    });
                    that.isBtnUpSup = false;
                } else if (that.selectData.length == 1) {
                    if (that.selectData[0].vender_code != '无供应商' && that.selectData[0].vender_code != '多供应商' && that.selectData[0].vender_code != '') {
                        that.isBtnRelease = false;
                    } else {
                        that.isBtnRelease = true;
                    }
                    that.isBtnUpSup = false;
                } else if (that.selectData.length < 1) {
                    that.isBtnRelease = true;
                    that.isBtnUpSup = true;
                }
            },
            // 根据ID获取详情数据
            editInfo() {
                let that = this;
                that.isShowEdit = true;
                that.isEdit = true;
                that.$store.commit('setSharedParams', {
                    Code: '',
                    List: that.selectData
                });
                let item = {
                    label: this.$t('getapi[103]'),
                    name: 'purorderview',
                    path: '/purorderview',
                    url: '/purorderview',
                    icon: 'video-play'
                };
                this.$router.push({
                    name: 'purorderview',
                    label: this.$t('getapi[103]'),
                    path: '/purorderview'
                });
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Pur/Order/PlanOrderExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PurRequisitionLineToOrderViewInfo",
                    fromname: that.$t('getapi[102]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            selectInfo(tab) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
            },
            add() {
                let that = this;
                that.isShowEdit = true;
                that.$refs.order.clearInput(that.isShowEdit, '');
            },
            updateVender() {
                let that = this;
                let parm = {};
                that.$http.urlpost('/Pur/Order/PlanOrderUpdateVedner', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            // 选择供应商
            lct(scope) {
                let that = this
                console.log(scope)
                that.dataSetindex = scope.rowIndex;
                console.log(that.dataSetindex + '行')
                that.supplierVisible = true;
                //查询子参数
                let param = {
                    "part_code": scope.row.Part_Code,
                    "part_version": scope.row.Part_Version
                }
                that.$refs.supplier.clearInput(this.supplierVisible,param);
            },
            getSupplier(data) {
                let that = this
                console.log(JSON.stringify(data) + '行' + that.dataSetindex + '数据' + JSON.stringify(that.dataSet[that.dataSetindex]))
                that.dataSet[that.dataSetindex].vender = data.vender_code
            },
            pinSelect (item, index) {
                setTimeout(() => {
                    const data = this.$refs.singleTable1.tableData // 获取所有数据
                    const origin = this.origin // 起点数 从-1开始
                    const endIdx = index.index // 终点数
                    if (this.pin && item.includes(data[origin])) { // 判断按住
                        const sum = Math.abs(origin - endIdx) + 1// 这里记录终点
                        const min = Math.min(origin, endIdx)// 这里记录起点
                        for(let i=0;i<sum;i++){
                            this.$refs.singleTable1.toggleRowSelection(data[min+i], true)
                        }
                        console.log(this.selectData.length)
                    } else {
                        this.origin = index.index // 没按住记录起点
                    }
                }, 100);
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .blue {
        background: #9dd9ff;
    }
    /deep/ .yellow {
        background: #fff866;
    }
</style>
